export var DashboardCategory;
(function (DashboardCategory) {
    DashboardCategory["Trends"] = "trends";
    DashboardCategory["Brands"] = "brands";
    DashboardCategory["Seasons"] = "seasons";
    DashboardCategory["Traffic"] = "traffic";
    DashboardCategory["Top20Brands"] = "top_20_brands";
})(DashboardCategory || (DashboardCategory = {}));
export var WidgetCategory;
(function (WidgetCategory) {
    WidgetCategory["MostViewedLooks"] = "most_viewed_looks";
    WidgetCategory["MostSavedToMoodboards"] = "most_saved_to_moodboards";
})(WidgetCategory || (WidgetCategory = {}));
export var CategoryOverviewSection;
(function (CategoryOverviewSection) {
    CategoryOverviewSection["RunwayShare"] = "runway_share";
    CategoryOverviewSection["Searches"] = "searches";
    CategoryOverviewSection["Moodboards"] = "moodboards";
})(CategoryOverviewSection || (CategoryOverviewSection = {}));
export var DashboardPackageEnum;
(function (DashboardPackageEnum) {
    DashboardPackageEnum["Master"] = "Master";
    DashboardPackageEnum["Demo"] = "Demo";
})(DashboardPackageEnum || (DashboardPackageEnum = {}));
export var DashboardEvolutionEnum;
(function (DashboardEvolutionEnum) {
    DashboardEvolutionEnum["Stable"] = "Stable";
})(DashboardEvolutionEnum || (DashboardEvolutionEnum = {}));
